module.exports = __webpack_public_path__ + "img/464.9835bdfb.jpg";